import ProductFilterPage from "./product-filter.page"

export default ProductFilterPage;
